export function detectBrowserAutomation({userAgent, host}: {userAgent: string; host: string}): boolean {
  const isHeadless = !!userAgent && /headless/i.test(userAgent);
  const isScreenshotServerHost = !!host && [`web-internal`].includes(host);

  return isHeadless || isScreenshotServerHost;
}
